import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';
import { divide } from 'mathjs';
import { responsiveFontSize } from '../Services/Utilities';
import SafeLatexViewComponent from './SafeLatexViewComponent';

class MultipleChoiceQuestionSolutionComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        console.log(this)
        return(
            <div style={{width:'100%'}}>
                {this.props.Question.Choices.map((c,index) => (

                    <div
                    className={this.props.Answers.map((m) => m.Id).includes(c.Id) ? 'square border border-primary' : ''}
                    key = {index} style = {{flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start', width:'100%'}}>
                        <div style = {{width:'10%', textAlign:'center'}}>
                            <h6 className="text-primary" style={{fontSize: responsiveFontSize(0.8)}}>
                                {index+1}
                            </h6>
                        </div>
                        <div style = {{width:'80%', flexDirection:'column', display:'flex', alignContent:'flex-start', alignItems:'flex-start'}}>
                        {c.Latex ? 
                                                    <SafeLatexViewComponent 
                                                        source = {c.Latex}
                                                    /> : <div/>}
                                                    <br/>
                                                    {c.ImageURL ? 
                                                    <img 
                                                        style = {{width: this.props.Width*0.3, height:(c.Image_Height/c.Image_Width)*this.props.Width*0.3, objectFit:'contain'}}
                                                        src = {c.ImageURL}
                                                    /> 
                                        : <div/>}
                        </div>
                        <div style = {{width:'10%'}}>
                        <h6 style={{fontSize: responsiveFontSize(0.8), color:c.Correct ? 'green' : 'red', textAlign:'center'}} >
                                                                {c.Correct ? '✔' : '✘'}
                                                            </h6>
                        </div>
                    </div>
                    ))}
            </div>
        )
    }

    
}

function MapStateToProps(state) {
    return {

    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(MultipleChoiceQuestionSolutionComponent)